import { BlackListQryType } from '@/components/black-list-banner/types';
import { PromBannerData } from '@/types';
export const tmpPromBannerData: PromBannerData = {
  imageSrcCn: 'https://st.moneydata.hk/res/fmd_mojo_static/BhAG0Ba3cGxF8LzwPjOv7AtgusdYPDBk.png',
  link: 'https://prom.wechatpay.com.hk/mojo/prom/app_4_1818/index.shtml?adtag=covid',
  bannerClick: 'wallet.cvirus.home.banner0_click',
  bannerBrow: 'wallet.cvirus.home.banner0_brow',
  blackListAckListId: '202203021818427201',
  blackListQryType: BlackListQryType.WHITE,
};
